import {STATE_OPTIONS} from '../../../Agent/constants';

export const fieldOptions = {
    criminalOffenseChargeType: {
        options: ['Misdemeanor', 'Felony'],
    },
    drugorAlcoholDependenceWithdrawalTreatmentStatus: {
        options: ['In treatment', 'Completed', 'Never treated'],
    },
    usCitizenship: {
        options: ['Yes', 'Permanent Resident', 'U.S. Visa Holder', 'No U.S. Visa - TIN only'],
    },
    usVisaType: {
        options: [
            'E1',
            'E2',
            'E3',
            'Eb5',
            'OPT-F1',
            'H1B',
            'H1C',
            'H2A',
            'H2B',
            'H4',
            'L1',
            'L2',
            'K1',
            'K3',
            'O1',
            'O3',
            'P1',
            'P2',
            'P3',
            'P4',
            'TN/TN1',
            'V1',
        ],
    },
    bmonth: {
        options: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
    },
    bday: {
        options: [
            '01',
            '02',
            '03',
            '04',
            '05',
            '06',
            '07',
            '08',
            '09',
            '10',
            '11',
            '12',
            '13',
            '14',
            '15',
            '16',
            '17',
            '18',
            '19',
            '20',
            '21',
            '22',
            '23',
            '24',
            '25',
            '26',
            '27',
            '28',
            '29',
            '30',
            '31',
        ],
    },
    byear: {
        options: [
            '1935',
            '1936',
            '1937',
            '1938',
            '1939',
            '1940',
            '1941',
            '1942',
            '1943',
            '1944',
            '1945',
            '1946',
            '1947',
            '1948',
            '1949',
            '1950',
            '1951',
            '1952',
            '1953',
            '1954',
            '1955',
            '1956',
            '1957',
            '1958',
            '1959',
            '1960',
            '1961',
            '1962',
            '1963',
            '1964',
            '1965',
            '1966',
            '1967',
            '1968',
            '1969',
            '1970',
            '1971',
            '1972',
            '1973',
            '1974',
            '1975',
            '1976',
            '1977',
            '1978',
            '1979',
            '1980',
            '1981',
            '1982',
            '1983',
            '1984',
            '1985',
            '1986',
            '1987',
            '1988',
            '1989',
            '1990',
            '1991',
            '1992',
            '1993',
            '1994',
            '1995',
            '1996',
            '1997',
            '1998',
            '1999',
            '2000',
            '2001',
            '2002',
            '2003',
            '2004',
            '2005',
            '2006',
            '2007',
            '2008',
            '2009',
            '2010',
            '2011',
            '2012',
            '2013',
            '2014',
            '2015',
            '2016',
            '2017',
            '2018',
            '2019',
            '2020',
            '2021',
            '2022',
            '2023',
            '2024',
            '2025',
            '2026',
        ],
    },
    gender: {options: ['Male', 'Female']},
    state: {
        options: STATE_OPTIONS,
    },
    maritalStatus: {
        options: ['Single', 'Married', 'Divorced', 'Separated', 'Widowed', 'Domestic Partnership'],
    },
    kidsNumber: {options: ['1', '2', '3', '4+']},
    tobaccoUsage: {
        options: [
            'Chewing Tobacco',
            'Cigarettes',
            'Cigars',
            'E-cigarettes',
            'Marijuana',
            'Nicotine Gum',
            'Nicotine Patch',
            'Pipe',
            'Snuff',
            'Other',
        ],
    },
    tobaccoMethod: {
        options: ['Vape', 'Edible', 'Smoke', 'Dip', 'Sniff', 'Patch', 'Topical', 'Chew'],
    },
    currentlyEmployed: {
        options: ['Employed', 'Homemaker - Spouse Employed', 'Unemployed', 'Retired', 'Student', 'Disability', 'Other'],
    },
    existingPolicyType: {
        options: [
            'Accidental',
            'Guaranteed issue',
            'Guaranteed universal life',
            'Indexed universal life',
            'Variable universal life',
            'Term',
            'Whole life',
            'Unknown',
        ],
    },
    behavioralRisks: {
        options: ['DUI', 'Suspended license', 'Criminal offense', 'Outstanding lien', 'Bankruptcy', 'Bad credit'],
    },
    shoppedPolicyType: {
        options: [
            'Accidental',
            'Guaranteed issue',
            'Guaranteed universal life',
            'Indexed universal life',
            'Variable universal life',
            'Term',
            'Whole life',
            "Don't know",
        ],
    },
    IntentFocus: {
        options: [
            'Saving for the future',
            'Getting retirement income soon',
            'Protecting today',
            'Building an inheritance for my family',
        ],
        optionValues: ['SAVINGS', 'RETIREMENT', 'PROTECTION', 'INHERITANCE'],
    },
    IntentFunding: {
        options: ['Lump sum', 'Monthly contributions', 'Mix of both'],
        optionValues: ['FUND_LUMP', 'FUND_MONTHLY', 'FUND_BOTH'],
    },
};
